var _stop, _stop2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgTruck = function SvgTruck(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(_id, ")"),
    fillRule: "evenodd",
    stroke: "#fff",
    d: "M3.833 7.082a.38.38 0 0 1 .39-.369h9.333a.38.38 0 0 1 .388.369v7.09c-.06.053-.117.107-.172.164H8.154a3.315 3.315 0 0 0-2.376-.984c-.73 0-1.403.23-1.945.615V7.082Zm9.077 9.467H9.016C8.948 18.19 7.524 19.5 5.778 19.5c-1.749 0-3.174-1.314-3.239-2.957-.584-.06-1.039-.53-1.039-1.1V7.082C1.5 5.656 2.719 4.5 4.222 4.5h9.334c1.503 0 2.722 1.156 2.722 2.582v.369h1.6c.704 0 1.38.258 1.888.722l1.9 1.734a2.52 2.52 0 0 1 .834 1.86v2.2c0 1.426-1.219 2.582-2.722 2.582h-.392c-.068 1.64-1.491 2.951-3.238 2.951-1.746 0-3.17-1.31-3.238-2.95Zm3.368-3.194a3.308 3.308 0 0 1 2.246.981h1.254a.38.38 0 0 0 .389-.369v-2.2a.36.36 0 0 0-.12-.266l-1.9-1.734a.4.4 0 0 0-.269-.103h-1.6v3.69Zm.619 2.585a.92.92 0 0 0-.749-.374c-.501 0-.907.385-.907.86 0 .476.406.86.907.86s.908-.384.908-.86a.821.821 0 0 0-.09-.373 1.089 1.089 0 0 1-.07-.113Zm-11.12-.374c-.5 0-.907.385-.907.86 0 .476.407.86.908.86.5 0 .907-.384.907-.86 0-.475-.406-.86-.907-.86Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 1.5,
    x2: 22.5,
    y1: 12,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17D3FF"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EA90"
  })))));
};
export default SvgTruck;